import { render } from "./RequestView.vue?vue&type=template&id=aecff612&scoped=true"
import script from "./RequestView.vue?vue&type=script&lang=js"
export * from "./RequestView.vue?vue&type=script&lang=js"

import "./RequestView.vue?vue&type=style&index=0&id=aecff612&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aecff612"]])

export default __exports__